import React from 'react'

import { ExpiredLink as ExpiredLinkComponent } from '@guiker/error-pages'

export const ExpiredLink: React.FC = () => {
  return <ExpiredLinkComponent />
}
